








































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { FORM101_DATA, OPEN_APPROVE_FORM_DIALOG, SET_OPEN_APPROVE_FORM_DIALOG } from '@/types/form.types';
import {
  APPROVE_FORM,
  APPROVE_FORM_ERRORS,
  MANAGER_LOADING,
  SET_MANAGER_LOADING,
} from '@/types/managerForm.types';
import { Form101DataModel } from '@/models/form/Form101Data.model';
import Spinner from '@/components/loading/Spinner.vue';

@Component({
  components: {
    Spinner,
  },
})
export default class ApproveFormModal extends Vue {

  @Action(APPROVE_FORM, StoreNamespace.MANAGER) public approveForm;

  @Mutation(SET_OPEN_APPROVE_FORM_DIALOG, StoreNamespace.FORM) public setOpenApproveFormDialog;
  @Mutation(SET_MANAGER_LOADING, StoreNamespace.MANAGER) public setManagerLoading;

  @Getter(OPEN_APPROVE_FORM_DIALOG, StoreNamespace.FORM) public openApproveFormDialog!: boolean;
  @Getter(FORM101_DATA, StoreNamespace.FORM) public form101Data!: Form101DataModel;
  @Getter(APPROVE_FORM_ERRORS, StoreNamespace.MANAGER) public serverErrorMessages!: string[];
  @Getter(MANAGER_LOADING, StoreNamespace.MANAGER) public managerLoading!: boolean;

  public closeDialog(): void {
    this.setOpenApproveFormDialog(false);
  }

  public confirmDialog(): void {
    this.setManagerLoading(true);
    this.approveForm({
      formId: this.form101Data.formId,
      officeNum: this.form101Data.officeNum,
      idNum: this.form101Data.idNum,
      positionNum: this.form101Data.positionNum,
    });
  }

  public destroyed() {
    this.setOpenApproveFormDialog(false);
  }

}
